import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface MetricCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  icon: ReactNode;
  className?: string;
}

export const MetricCard = ({ label, value, subtitle, icon, className }: MetricCardProps) => (
  <div className={cn('bg-white rounded-lg border border-slate-200 p-4 flex items-start gap-3', className)}>
    <div className="p-2 bg-emerald-50 rounded-md text-emerald-600 shrink-0">
      {icon}
    </div>
    <div className="min-w-0">
      <p className="text-xs text-slate-500 font-medium uppercase tracking-wide">{label}</p>
      <p className="text-2xl font-bold text-slate-800 leading-tight">{value}</p>
      {subtitle && <p className="text-xs text-slate-400 mt-0.5 truncate">{subtitle}</p>}
    </div>
  </div>
);
